import { $http } from "@/plugins/api";

import type { Commit } from "vuex";
import type { CardsData } from "./types";

interface State {
  luresSent: number | null;
  luresClicked: number | null;
  protectedCustomers: number | null;
  atRiskCustomers: number | null;
  satCardsData: CardsData;
}
const defaultState = () => {
  return {
    luresSent: null,
    luresClicked: null,
    protectedCustomers: null,
    atRiskCustomers: null,
    satCardsData: {
      modules_sent: 0,
      at_risk: 0,
      protected: 0,
      active_users: 0,
      licences: 0,
      optionals: null,
    },
  };
};

const state: State = defaultState();

export const getters = {
  luresSent: (state: State) => state.luresSent,
  luresClicked: (state: State) => state.luresClicked,
  atRiskSat: (state: State) => state.satCardsData.at_risk,
  protectedSat: (state: State) => state.satCardsData.protected,
  protectedCustomers: (state: State) => state.protectedCustomers,
  atRiskCustomers: (state: State) => state.atRiskCustomers,
};

export const actions = {
  async getSatCardData(
    { commit }: { commit: Commit },
    {
      globalOrganisationID,
    }: {
      globalOrganisationID: string;
    },
  ) {
    const res = await $http.get(
      `${
        import.meta.env.VITE_API_CLIENT
      }/v1/cams/manager/sat/${globalOrganisationID}/customers/cards`,
    );
    commit("setSatCardsData", res.data);
  },
  async getAtRiskAndProtected(
    { commit }: { commit: Commit },
    {
      globalOrganisationID,
    }: {
      globalOrganisationID: string;
    },
  ) {
    const res = await $http.get(
      `${
        import.meta.env.VITE_API_CLIENT
      }/v1/cams/manager/${globalOrganisationID}/cards/at-risk`,
    );

    commit("setAtRiskAndProtected", res.data);
  },
};

const mutations = {
  setLuresSentAndClicked: (
    state: State,
    {
      lures_sent,
      links_clicked,
    }: { lures_sent: number; links_clicked: number },
  ) => {
    state.luresClicked = links_clicked;
    state.luresSent = lures_sent;
  },
  setAtRiskAndProtected: (
    state: State,
    data: { protected: number; at_risk: number },
  ) => {
    state.atRiskCustomers = data.at_risk;
    state.protectedCustomers = data.protected;
  },
  setSatCardsData: (state: State, data: CardsData) => {
    state.satCardsData = data;
  },
  resetCards: (state: State) => Object.assign(state, defaultState()),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
